export default {
    baseUrl: '/baseUrl',
    pyUrl: '/pyUrl',
    mapUrl: {
        electronicMap: "https://t{s}.tianditu.gov.cn/vec_w/wmts?tk=e2e24450e10e61c3d237f447cf9b7369&SERVICE=WMTS&REQUEST=GetTile&VERSION=1.0.0&LAYER=vec&STYLE=default&TILEMATRIXSET=w&FORMAT=tiles&TileMatrix={z}&TileCol={x}&TileRow={y}",
        remoteSensingImage: "https://t{s}.tianditu.gov.cn/img_w/wmts?tk=e2e24450e10e61c3d237f447cf9b7369&SERVICE=WMTS&REQUEST=GetTile&VERSION=1.0.0&LAYER=img&STYLE=default&TILEMATRIXSET=w&FORMAT=tiles&TileMatrix={z}&TileCol={x}&TileRow={y}",
    }
}
